module.exports = __webpack_public_path__ + "static/fun-time/games/page001_game0/audio//Track_8_Story_1_Hello Lisa_.mp3";